import React from "react";
import { Outlet } from "react-router-dom";
import AdminSidebar from "layouts/AdminSidebar";
import PanelNavbar from "layouts/PanelNavbar";

const AdminLayout = () => {
  return (
    <div
      style={{
        display: "flex",
        backgroundColor: "#f4f4f4",
        minHeight: "100vh",
      }}
    >
      <AdminSidebar />
      <div style={{ marginLeft: "240px", flex: 1 }}>
        <PanelNavbar />
        <main style={{ padding: "20px" }}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
